<script setup lang="ts">
import { appContainer } from "../container";
import router from "../routes";
import { AuthService } from "../services/authService";
import { LoadingService } from "../services/loadingService";

const authService = appContainer.resolve(AuthService);
const loadingService = appContainer.resolve(LoadingService);

async function logout() {
  const loader = await loadingService.show();
  await authService.logout().finally(() => loader.hide());
}
</script>
<template>
  <div
    class="d-flex align-items-center justify-content-center w-100 text-center px-4"
  >
    <div class="flex-column flex-center">
      <div class="flex-center"></div>
      <h1 class="ff-montserrat fw-semibold">Page Doesn't Exist!</h1>
      <h3 class="ff-montserrat mb-4 text-body-tertiary">
        Sorry, the page you're looking for could not be found
      </h3>
      <button
        class="btn btn-primary text-white"
        @click="router.push(`/dashboard`)"
      >
        Home
      </button>
      <button
        class="logout-btn btn d-flex align-items-center mx-auto text-danger mt-2"
        @click="logout()"
      >
        <i class="bi bi-power"></i>Log Out
      </button>
    </div>
  </div>
</template>

<style lang="css" scoped>
i {
  font-size: 22px;
}
.logout-btn {
  gap: 12px;
  border: none !important;
  cursor: pointer;
  user-select: none;
}
</style>
